import { v4 as uuidv4 } from 'uuid';
import GoodsGroupByGoodPluginSettings from './GoodsGroupByGoodPluginSettings';
import { GoodsGroupByGoodGrid } from './GoodsGroupByGoodGrid';
import { useTranslation } from 'react-i18next';

export const GoodsGroupByGoodTab = (): ITab => {
    const { t } = useTranslation();
    return {
        id: uuidv4(),
        title: t("directory.goods.goodsGroup"),
        view: {
            content:    GoodsGroupByGoodPluginSettings
                        ? <GoodsGroupByGoodGrid gridId={uuidv4()} plugin={GoodsGroupByGoodPluginSettings} />
                        : <p>{t('general.directoryNotConfigured')}</p>
        }
    }
}

export default GoodsGroupByGoodTab
